
import React from 'react';
import { RentalMileageHistory } from '@/components/admin/mileage/RentalMileageHistory';
import { MileageSystemFixer } from '@/components/admin/mileage/MileageSystemFixer';
import { MileageSystemTester } from '@/components/admin/mileage/MileageSystemTester';

const MileagePage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Управление пробегом</h1>
        <p className="text-muted-foreground">
          Просмотр, управление и тестирование системы расчета пробега
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="space-y-6">
          <MileageSystemFixer />
          <MileageSystemTester />
        </div>
        
        <div className="lg:col-span-2">
          <RentalMileageHistory limit={20} />
        </div>
      </div>
    </div>
  );
};

export default MileagePage;
